import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

// Lot 774 — cartes Yalola à la place des dialogues du navigateur (window.confirm / window.prompt) dans la console support.

// Confirmation : { title, description, confirmLabel, danger } — onConfirm() appelé au clic.
export const ConfirmCard = ({ open, onOpenChange, title, description, confirmLabel = "Confirmer", cancelLabel = "Annuler", danger = false, onConfirm, testId = "confirm-card" }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid={testId}>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        {description && <AlertDialogDescription data-testid={`${testId}-text`}>{description}</AlertDialogDescription>}
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="rounded-full" data-testid={`${testId}-cancel`}>{cancelLabel}</AlertDialogCancel>
        <AlertDialogAction className="rounded-full" onClick={onConfirm} style={danger ? { background: "#B91C1C" } : undefined} data-testid={`${testId}-confirm`}>{confirmLabel}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

// Saisie d'un texte : onConfirm(value) ; `required` bloque l'envoi d'un texte vide.
export const PromptCard = ({ open, onOpenChange, title, description, placeholder = "", defaultValue = "", confirmLabel = "Valider", required = false, busy = false, onConfirm, children, testId = "prompt-card", icon = null }) => {
  const [value, setValue] = useState(defaultValue);
  useEffect(() => { if (open) setValue(defaultValue); }, [open, defaultValue]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid={testId}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">{icon}{title}</DialogTitle>
          {description && <DialogDescription data-testid={`${testId}-text`}>{description}</DialogDescription>}
        </DialogHeader>
        {children}
        <Textarea rows={3} value={value} onChange={(e) => setValue(e.target.value)} placeholder={placeholder} autoFocus data-testid={`${testId}-input`} />
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" className="rounded-full" onClick={() => onOpenChange(false)} disabled={busy} data-testid={`${testId}-cancel`}>Annuler</Button>
          <Button className="pill-primary rounded-full" onClick={() => onConfirm(value.trim())} disabled={busy || (required && !value.trim())} data-testid={`${testId}-confirm`}>
            {busy && <Loader2 size={14} className="mr-1 animate-spin" />}{confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
